import { BorderRadius, Color, getDefaultTransition, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const BaseAccountCardWrapper = styled.div`
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  justify-content: space-between;
  min-width: 250px;
  height: 200px;
  margin-bottom: ${Spacing.S8};
  padding: ${Spacing.S16};
  border: 1px solid ${Color.Grey200};
  border-radius: ${BorderRadius.R12};
  position: relative;
  background-color: ${Color.White};
  cursor: pointer;
  ${getDefaultTransition('background-color', 'border-color', 'box-shadow')};

  &:hover {
    border-color: ${Color.Grey200};
    background-color: ${Color.Grey50};
  }
`

export const InteractiveElement = styled.div`
  position: relative;
  z-index: 2;
  cursor: default;
`

export const TopSection = styled.div`
  display: grid;
  align-items: start;
  gap: ${Spacing.S12};
  grid-template-columns: 1fr auto;
`

export const LogoWrapper = styled.div`
  width: 40px;
`
